/**
 * GX Medical Professionals — carousel + video modal
 */
(function () {
  function initProfessionals(root) {
    if (!root || root.dataset.gxProfInit === '1') return;
    root.dataset.gxProfInit = '1';

    var modal = root.querySelector('[data-gx-prof-modal]');
    var closeBtn = root.querySelector('[data-gx-prof-modal-close]');
    var modalTitle = root.querySelector('[data-gx-prof-modal-title]');
    var modalContent = root.querySelector('[data-gx-prof-modal-content]');
    var modalEmbed = root.querySelector('[data-gx-prof-modal-embed]');
    var modalSim = root.querySelector('[data-gx-prof-modal-sim]');
    var cards = root.querySelectorAll('[data-gx-prof-card]');
    var track = root.querySelector('[data-gx-prof-track]');
    var slider = root.querySelector('[data-gx-prof-slider]');
    var prevBtn = root.querySelector('[data-gx-prof-prev]');
    var nextBtn = root.querySelector('[data-gx-prof-next]');
    var lastFocused = null;

    function openModal(card) {
      if (!modal) return;
      var title = card.getAttribute('data-video-title') || '';
      var themeColor = card.getAttribute('data-video-theme') || '#111';
      var videoUrl = card.getAttribute('data-video-url') || '';
      var videoSource = card.getAttribute('data-video-source') || '';
      var blockId = card.getAttribute('data-video-block-id') || '';
      var templatesRoot = root.querySelector('[data-gx-prof-video-templates]');

      if (modalTitle) modalTitle.textContent = title;
      if (modalContent) {
        modalContent.style.background = 'linear-gradient(135deg, ' + themeColor + ' 0%, #111111 100%)';
      }

      if (modalEmbed && modalSim) {
        modalEmbed.innerHTML = '';
        if (videoSource === 'shopify' && templatesRoot && blockId) {
          var tpl = templatesRoot.querySelector('[data-gx-prof-video-for="' + blockId + '"]');
          if (tpl && tpl.content) {
            modalEmbed.hidden = false;
            modalSim.hidden = true;
            if (modalTitle) modalTitle.hidden = true;
            modalEmbed.appendChild(tpl.content.cloneNode(true));
            var video = modalEmbed.querySelector('video');
            if (video) {
              video.setAttribute('aria-label', title);
              video.play().catch(function () {});
            }
          } else {
            modalEmbed.hidden = true;
            modalSim.hidden = false;
            if (modalTitle) modalTitle.hidden = false;
          }
        } else if (videoUrl) {
          modalEmbed.hidden = false;
          modalSim.hidden = true;
          if (modalTitle) modalTitle.hidden = true;
          var iframe = document.createElement('iframe');
          iframe.className = 'gx-video-embed';
          iframe.src = videoUrl;
          iframe.title = title;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          modalEmbed.appendChild(iframe);
        } else {
          modalEmbed.hidden = true;
          modalSim.hidden = false;
          if (modalTitle) modalTitle.hidden = false;
        }
      }

      lastFocused = document.activeElement;
      modal.classList.add('active');
      modal.removeAttribute('hidden');
      modal.inert = false;
      modal.setAttribute('aria-hidden', 'false');
      if (closeBtn) closeBtn.removeAttribute('tabindex');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('active');
      modal.setAttribute('hidden', '');
      modal.inert = true;
      modal.setAttribute('aria-hidden', 'true');
      if (closeBtn) closeBtn.setAttribute('tabindex', '-1');
      if (modalEmbed) {
        var activeVideo = modalEmbed.querySelector('video');
        if (activeVideo) {
          activeVideo.pause();
          activeVideo.removeAttribute('src');
          activeVideo.load();
        }
        modalEmbed.innerHTML = '';
        modalEmbed.hidden = true;
      }
      if (modalSim) modalSim.hidden = false;
      if (modalTitle) modalTitle.hidden = false;
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { openModal(card); });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (modal) {
      if (closeBtn) closeBtn.setAttribute('tabindex', '-1');
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('active')) {
        closeModal();
      }
    });

    if (track && slider && prevBtn && nextBtn) {
      function getScrollStep() {
        var card = track.querySelector('[data-gx-prof-card]');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        return card.offsetWidth + gap;
      }

      function updateSliderControls() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        var hasOverflow = maxScroll > 4;

        if (hasOverflow) {
          slider.setAttribute('data-gx-prof-overflow', '');
        } else {
          slider.removeAttribute('data-gx-prof-overflow');
        }

        var scrollLeft = track.scrollLeft;
        var isAtStart = scrollLeft <= 8;
        var isAtEnd = scrollLeft >= maxScroll - 8;
        prevBtn.disabled = !hasOverflow || isAtStart;
        nextBtn.disabled = !hasOverflow || isAtEnd;
      }

      function scrollProf(direction) {
        var step = getScrollStep();
        track.scrollBy({
          left: direction === 'next' ? step : -step,
          behavior: 'smooth'
        });
      }

      prevBtn.addEventListener('click', function () { scrollProf('prev'); });
      nextBtn.addEventListener('click', function () { scrollProf('next'); });
      track.addEventListener('scroll', updateSliderControls, { passive: true });
      window.addEventListener('resize', updateSliderControls, { passive: true });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          scrollProf('next');
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          scrollProf('prev');
        }
      });

      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(updateSliderControls);
        ro.observe(track);
      }

      updateSliderControls();
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gx-prof-root]').forEach(initProfessionals);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { boot(e.target); });
})();
